import Vue from 'vue'
import Vuex, { StoreOptions } from 'vuex'
import { RootState } from '@/store/RootState'
import { getters } from '@/store/getters'
import { mutations } from '@/store/mutations'
import { actions } from '@/store/actions'

Vue.use(Vuex)

export const TOKEN = 'token'
export const LAST_LOGGED_IN_USER = 'lastLoggedInUser'
export const LOGGED_IN_USER = 'loggedInUser'

const store: StoreOptions<RootState> = {
  state: {
    msisdn: null,
    msisdns: [],
    msisdnsBundles: [],
    unreadMessages: 0,
    headerData: null,
    navigation: null,
    pageData: [],
    stickyPage: null,
    viewActive: 'main',
    viewContent: '',
    leftViewActive: false,
    leftViewContent: '',
    leftViewTitle: '',
    allowResend: false,
    cardBackground: '#FFFFFF',
    postParams: null,
    userLocation: null,
    token: sessionStorage.getItem(TOKEN) || localStorage.getItem(TOKEN) || '',
    lastLoggedInUser: sessionStorage.getItem(LAST_LOGGED_IN_USER) || localStorage.getItem(LAST_LOGGED_IN_USER) || '',
    hasPin: false,
    currentNavigationKey: '',
    refreshLeftView: false,
    errorOccurred: false,
    billValues: [],
    jumpOnCloseURI: '',
    audio: null,
    rootElClasses: '',
    searchVisible: false,
    searchData: null,
    currentUserAvatar: ''
  },
  getters,
  mutations,
  actions
}

export default new Vuex.Store<RootState>(store)
